import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = ({ onLogout }: { onLogout: () => void }) => {
  const navigate = useNavigate();

  useEffect(() => {
    onLogout();
    navigate("/login", { replace: true });
  }, [onLogout, navigate]);

  return null;
};

export default Logout;
